import Modal from "react-bootstrap/Modal";

export const EmiModal = (props) => {
  const { show, onClose, emis, totalCost, interval } = props;
  const isDaily = interval !== "month";
  const unitLabel = isDaily ? "Days" : "Months";
  const planLabel = isDaily ? "Daily Split Plan" : "Monthly Split Plan";
  return (
    <Modal
      size="md"
      aria-labelledby="event-emi-modal-title"
      centered
      show={show}
      onHide={onClose}
      dialogClassName="event-emi-modal-dialog"
      contentClassName="event-emi-modal"
    >
      <Modal.Header closeButton className="event-emi-modal-header">
        <Modal.Title id="event-emi-modal-title">
          Split Payment Option
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="event-emi-modal-body">
        <table className="event-emi-modal-table">
          <thead>
            <tr>
              <th scope="col">{planLabel}</th>
              <th scope="col">Total Cost</th>
            </tr>
          </thead>
          <tbody>
            {emis?.map((item, index) => {
              return (
                <tr key={index}>
                  <td>
                    USD <strong>{item?.amount}</strong> X {item?.months} {unitLabel}
                  </td>
                  <td>USD {totalCost}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Modal.Body>
    </Modal>
  );
};
